import * as React from "react";
import { useRef } from "react";

import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import {
  ActionIcon,
  Card,
  Divider,
  Group,
  NumberInput,
  NumberInputHandlers,
  Switch,
  Text,
} from "@mantine/core";
import { NumberInputProps } from "@mantine/core/lib/NumberInput/NumberInput";
import { SwitchProps } from "@mantine/core/lib/Switch/Switch";

import { TokenDistributionType } from "apollo/graphql.generated";

type Props = {
  enableLimitInputProps: SwitchProps;
  limitInputProps: NumberInputProps;
  distributionType: TokenDistributionType;
};

export const SaleLimitMintsInput: React.FC<Props> = ({
  enableLimitInputProps,
  limitInputProps,
  distributionType,
}) => {
  const limitNumberOfMintsHandlers = useRef<NumberInputHandlers>();

  if (distributionType !== TokenDistributionType.Mint) return <></>;

  return (
    <Card p="xs">
      <Group position="apart" align="center">
        <Text size="sm">Limit number of mints per wallet</Text>
        <Switch mt={4} {...enableLimitInputProps} />
      </Group>
      {enableLimitInputProps.checked && (
        <>
          <Divider my="xs" />
          <Group position="apart" align="stretch">
            <Text size="sm">Maximum mints allowed per wallet</Text>
            <Group spacing={0}>
              <NumberInput
                min={1}
                max={10000}
                {...limitInputProps}
                handlersRef={limitNumberOfMintsHandlers}
                hideControls
                hidden
              />
              <Text size="sm" mr="8px">
                {limitInputProps.value}
              </Text>
              <ActionIcon
                size={20}
                color={SECONDARY_COLOR}
                onClick={() => limitNumberOfMintsHandlers?.current?.decrement()}
                mr="1px"
              >
                –
              </ActionIcon>
              <ActionIcon
                size={20}
                color={SECONDARY_COLOR}
                onClick={() => limitNumberOfMintsHandlers?.current?.increment()}
              >
                +
              </ActionIcon>
            </Group>
          </Group>
        </>
      )}
    </Card>
  );
};
